import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { WelcomeRevealService } from 'src/app/services/onboarding/welcome-reveal.service';
import { WelcomeStageComponent } from '../welcome-stage/welcome-stage.component';

/**
 * "Your workspace is ready" over the real dashboard, right after
 * onboarding (the Framer loader). `WelcomeRevealService` runs the sequence;
 * this renders its message, and the layout reads `phase()` to tilt and
 * reveal the dashboard.
 */
@Component({
  selector: 'app-welcome-reveal',
  templateUrl: './welcome-reveal.component.html',
  imports: [NgClass, TranslocoModule, WelcomeStageComponent],
  host: { class: 'contents' },
})
export class WelcomeRevealComponent {
  protected readonly reveal = inject(WelcomeRevealService);

  /** Null when no reveal is running. */
  readonly phase = this.reveal.phase;

  protected enter(): void {
    this.reveal.enter();
  }
}
